<p style="color:rgb(15, 15, 15);">Add Support Request:</p>
<form [formGroup]="supportForm">
    <div class="content-padding">
        <div class="row">
            <div class="col-md-6">
                <label for="name">Contact Person<span class="required-sign" style="color: red">*</span></label>
                <input type="text" class="form-control" id="contactPerson" name="BankName" value=""
                    formControlName="contactPerson" [ngClass]="{ 'is-invalid': submitted && f.contactPerson.errors }"
                    placeholder="Contact Person">
                <div *ngIf="submitted && f.contactPerson.errors" class="invalid-feedback">
                    <div *ngIf="f.contactPerson.errors.required">Contact Person is required</div>
                </div>

            </div>
            <div class="col-md-6">

                <label for="name">Contact No<span class="required-sign" style="color: red">*</span></label>
                <input type="text" class="form-control" id="contactNo" name="contactNo" value="" maxlength="10"
                    formControlName="contactNo" placeholder="Contact Number"
                    [ngClass]="{ 'is-invalid': submitted && f.contactNo.errors }">
                <div *ngIf="submitted && f.contactNo.errors" class="invalid-feedback">
                    <div *ngIf="f.contactNo.errors.required">Contact Number is required</div>
                </div>

            </div>
            <div class="col-md-6">

                <label for="name">Issue<span class="required-sign" style="color: red">*</span></label>
                <select id="issue" class="form-control" name="issue" formControlName="issue"
                    [ngClass]="{ 'is-invalid': submitted && f.issue.errors }">
                    <option *ngFor="let p of issueType" [value]="p.text">
                        <span> {{p.text }} </span>
                    </option>
                </select>
                <div *ngIf="submitted && f.issue.errors" class="invalid-feedback">
                    <div *ngIf="f.issue.errors.required">Issue is required</div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="name">Remarks</label>
                <input type="text" class="form-control" id="Remarks" name="remarks" value="" formControlName="remarks"
                    placeholder="Remarks">

            </div>
            <div class="form-group">
                <label>
                    <input type="radio" value=1 formControlName="isFieldSupport">
                    <span>Phone</span>
                </label>
                <label>
                    <input type="radio" value=0 formControlName="isFieldSupport">
                    <span>Field</span>
                </label>
                <div *ngIf="submitted && f.isFieldSupport.errors" class="invalid-feedback">
                    <div *ngIf="f.isFieldSupport.errors.required"> Support Type is required</div>
                </div>
            </div>

            <div class="form-group">
                <label class="checkbox-inline" for="priority">
                    <input type="checkbox" name="priority" formControlName="priority" />
                    <p>Priority</p>
                </label>
            </div>
        </div>
    </div>
</form>